import { NgModule } from '@angular/core';
import { ProfileEffects } from './profile.effects';
import { EffectsModule } from '@ngrx/effects';
import { SocketIoComponent } from './socket-io.component';

@NgModule({
  declarations: [
    SocketIoComponent
  ],
  exports: [
    SocketIoComponent
  ],
  imports: [
//    EffectsModule.forFeature([ProfileEffects]),
  ]
})
export class ProfileModule { }
